// @flow

import React from "react";

import { SelectedUser as StyledUser } from "./styles";
import Icon from "src/icons";

type Props = {
  email: string,
  removeSelectedUser: Function,
};

const SelectedEmail = ({ email, removeSelectedUser }: Props) => {
  return (
    <StyledUser>
      <span>{email}</span>
      <Icon type="detach" handleClick={() => removeSelectedUser(email)} />
    </StyledUser>
  );
};

export default SelectedEmail;
